export class Organisation {
    public OrganisationName!: string;
    public NtmUrl!: string;
    public SsoUrl!: string;
    public SsoSecret!: string;
}
